import { createFileRoute } from '@tanstack/react-router';
import { GlobalAiSettingsPage } from '@/pages/admin/settings/GlobalAiSettingsPage';

export const Route = createFileRoute('/admin/settings/')({
  component: GlobalAiSettingsPage
});
